<template>
  <div class="chatbot-q">
    <Disclaimer v-if="disclaimerShow" :confirm="disclaimerConfirm" :cancel="disclaimerCancel" />
    <el-avatar class="chat-avatar" :src="chatHead"></el-avatar>
    <div class="chatbot-q-content">
      <p v-html="answer"></p>
      <div v-if="isMultiQuestion">
        <el-button class="q-btn red" :disabled="disableYesBtn" @click="getYes('是')"> 是 </el-button>
        <el-button class="q-btn" :disabled="disableNoBtn" @click="getNo('否')"> 否 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageList, logisticsNextStep } from "@/utils/index";
import { updateMessageList } from "@/utils/index";
import Disclaimer from "@/views/disclaimer.vue";

export default {
  name: "GetAnswer",
  components: {
    Disclaimer,
  },
  data() {
    // console.log(this.answer, this.history, this.lastItem);
    return {
      chatHead: "/static/images/chat-head.png",
      disableYesBtn: this.history && !this.lastItem,
      disableNoBtn: this.history && !this.lastItem,
      disclaimerShow: false,
      orderId: "",
    };
  },
  watch: {
    lastItem: function (val) {
      this.disableNoBtn = !val;
      this.disableYesBtn = !val;
    },
    history: function (val) {
      this.disableNoBtn = val;
      this.disableYesBtn = val;
    },
  },
  created() {
    window.nextStep = this.nextStep;
    window.gotoLogisticsDetails = this.gotoLogisticsDetails;
    window.openLink = this.openLink;
  },
  methods: {
    async getNo(value) {
      // console.log("getNo");
      this.disableYesBtn = true;
      this.disableNoBtn = true;
      const that = this;
      getMessageList(value, that);
      const itemId = this.$store.getters.get_itemId;
      updateMessageList(that, itemId);
    },
    async getYes(value) {
      // console.log("getYes");
      this.disableYesBtn = true;
      this.disableNoBtn = true;
      const that = this;
      getMessageList(value, that);
      const itemId = this.$store.getters.get_itemId;
      updateMessageList(that, itemId);
    },
    nextStep: function (goods, timestamp, orderId, mailNo, status) {
      // console.log("nextStep", goods, timestamp, orderId, mailNo, status);
      const that = this;
      logisticsNextStep(goods, timestamp, orderId, mailNo, status, that);
    },
    gotoLogisticsDetails: function (orderId) {
      this.orderId = orderId;
      this.disclaimerShow = true; // 显示免责声明
    },
    disclaimerConfirm: function () {
      // 免责声明确认按钮
      const url = process.env.VUE_APP_LINK_2.replaceAll(
        "{orderId}",
        this.orderId
      );
      window.location.href = url;
      this.disclaimerCancel();
    },
    disclaimerCancel: function () {
      // 免责声明取消
      this.disclaimerShow = false;
    },
    openLink: function (value) {
      window.location.href = value;
    },
  },
  props: {
    answer: String,
    isMultiQuestion: Boolean,
    history: {
      type: Boolean,
      default: false,
    },
    lastItem: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
.chatbot-q {
  position: relative;
  float: left;
  width: 100%;
  width: 85%;
  text-align: left;
  padding-left: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.chatbot-q-content {
  margin-top: 10px;
  border: 1px solid #efefef;
  padding-left: 10px;
  padding-right: 10px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding-bottom: 10px;
  line-height: 27px;
}

.chatbot-q-content img {
  width: 100%;
  height: 100%;
}

.q-btn {
  background-color: #fff;
  border-color: #d72618;
  color: #d72618;
  padding: 5px 22px !important;
  border-radius: 25px;
}

.chat-avatar {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -20px;
  left: 0;
}

a {
  color: #d72618;
}

.open_webapp {
  display: inline-block;
}

.button {
  text-decoration: underline;
  color: #d72618;
  cursor: pointer;
}

#launch-btn script {
  display: inline;
  text-decoration: underline;
  color: #d72618;
  cursor: pointer;
  font-size: 16px;
}
#launch-btn script span {
  font-size: 16px;
}
</style>